module.exports = __webpack_public_path__ + "img/amex.e90e5a7b.svg";